class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this._debounceTimer = null;
    this._fetching = false;
    this.bindAddButtons();
    this.loadRecommendations();
    document.addEventListener('cart:update', this._onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this._onCartUpdate);
    clearTimeout(this._debounceTimer);
  }

  async loadRecommendations() {
    const sourceId = this.dataset.sourceId;
    const limit = parseInt(this.dataset.limit || '4', 10);
    if (!sourceId || sourceId === '') return;

    try {
      const r = await fetch(`/recommendations/products.json?product_id=${sourceId}&limit=${limit}&intent=related`);
      if (!r.ok) return;
      const data = await r.json();
      if (data.products && data.products.length > 0) {
        this.renderProducts(data.products);
        this.bindAddButtons();
      }
    } catch (e) {
      // SSR fallback reste en place
    }
  }

  renderProducts(products) {
    this.track.innerHTML = products.map(p => {
      const v = p.variants[0];
      const imgTag = p.featured_image
        ? `<img src="${p.featured_image}" alt="${this.esc(p.title)}" loading="lazy" width="56" height="56">`
        : '';
      return `<article class="cart-upsell__card" data-product-handle="${p.handle}">
        <a href="${p.url}" class="cart-upsell__card-image">${imgTag}</a>
        <div class="cart-upsell__card-body">
          <p class="cart-upsell__card-title">${this.esc(p.title)}</p>
          <span class="cart-upsell__card-price">${this.formatMoney(p.price)}</span>
        </div>
        <button class="cart-upsell__card-add" type="button" data-add-product data-variant-id="${v.id}" aria-label="Ajouter au panier" ${v.available ? '' : 'disabled'}>
          ${v.available ? '+' : '×'}
        </button>
      </article>`;
    }).join('');
  }

  esc(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  bindAddButtons() {
    this.querySelectorAll('[data-add-product]').forEach(btn => {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', this._handleAdd);
    });
  }

  _handleAdd = async (e) => {
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    try {
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(el => el.dataset.sectionId).filter(Boolean).join(',');
      const body = { id: parseInt(variantId, 10), quantity: 1 };
      if (sectionIds) body.sections = sectionIds;

      const r = await fetch(this.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || 'Erreur');

      btn.textContent = '✓';

      const evt = new Event('cart:update', { bubbles: true });
      evt.detail = {
        resource: data,
        sourceId: 'cart-upsell',
        data: {
          source: 'cart-upsell',
          itemCount: 1,
          variantId: String(variantId),
          sections: data.sections || {}
        }
      };
      document.dispatchEvent(evt);

      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
    } catch (err) {
      btn.textContent = 'Erreur';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
    }
  };

  _onCartUpdate = (e) => {
    if (e.detail && e.detail.sourceId === 'cart-upsell') return;
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        this.style.display = cart.item_count > 0 ? '' : 'none';
      }).catch(() => {});
    }, 600);
  };
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}
